module.exports = __webpack_public_path__ + "static/img/fish6.44cb3bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish6.png
// module id = tIqR
// module chunks = 0